import { useNavigation } from '@remix-run/react';
export function useIsNavigationIddle() {
    const navigation = useNavigation();
    return navigation.state === 'idle';
}
